<template>
  <div class="d-flex flex-column">
    <v-slider
        :value="value"
        ticks="always"
        tick-size="4"
        step="1"
        min="1"
        max="5"
        color="primary"
        dense
        hide-details
        :readonly="readonly"
        @input="handleInput"
    />
    <div class="d-flex flex-row justify-space-between">
      <div class="body-2 ml-2 mt-n2">
        <slot name="left"/>
      </div>
      <div class="body-2 mr-2 mt-n2">
        <slot name="right"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RateSlider",
  props: {
    value: {
      type: Number,
      default: 3
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  methods: {
    handleInput(value) {
      this.$emit("input", value)
    }
  }
}
</script>

<style scoped>

</style>